export function loadStyles() {
    return new Promise((resolve, reject) => {
        console.log('Loading styles');
        import(/* webpackChunkName: "main-styles" */ '../../styles/main.scss')
            .then((module) => {
                console.log('Styles Module loaded:', module);
                if (module && module.default && typeof module.default.use === 'function') {
                    // If the imported module has a `use` function, call it
                    module.default.use();
                }
                
                // Use MutationObserver to detect when styles are applied
                const observer = new MutationObserver((mutations, obs) => {
                    console.log('MutationObserver triggered, checking for main-styles');
                    const styleSheet = document.querySelector('link[href*="main-styles"]');
                    if (styleSheet) {
                        obs.disconnect();
                        console.log('Styles loaded');
                        resolve();
                    } else {
                        console.log('Styles not loaded yet');
                    }
                });
                
                observer.observe(document.head, {
                    childList: true,
                    subtree: true
                });
                
                // Fallback timeout in case the styles don't load
                setTimeout(() => {
                    observer.disconnect();
                    reject(new Error('Styles loading timeout'));
                }, 60000);
            })
            .catch((error) => {
                console.error('Error loading styles:', error);
                reject(error);
            });
    });
}